/* global swal:false */
(function() {
  'use strict';

  angular
    .module('singup.service', [])
    .factory('SignupService', SignupService);

  /** @ngInject */
  function SignupService($http, $q, API) {

    function signup(model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'users', model)
            .success(defer.resolve)
            .error(function(){
                swal("Existing Account!", "", "error");
            });

        return defer.promise;
    }

    return{
        signup: signup
    };

  }

})();
